import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up\"><path d=\"M877.254 402.746l-320-320c-24.992-24.994-65.514-24.994-90.508 0l-320 320c-24.994 24.994-24.994 65.516 0 90.51 24.994 24.996 65.516 24.996 90.51 0L448 282.51 448 896c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64L576 282.51l210.746 210.746C799.242 505.752 815.622 512 832 512s32.758-6.248 45.254-18.746C902.248 468.26 902.248 427.74 877.254 402.746z\" p-id=\"48074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol